var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "62px",
    viewBox: "0 0 38 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED4C38A2-E79C-4494-8811-E932AE15FF07@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AMP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AMP_v1",
    transform: "translate(-781.000000, -4230.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-yandex-red",
    transform: "translate(781.000000, 4231.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36,26.47056 C35.2595814,29.1837496 34.4608268,31.4552706 33.6037356,33.2851233 C32.7466445,35.114976 31.2117522,37.825691 28.999059,41.4172686 L16,60.608491 L19.3337476,38.6863908 L19.3582776,38.6574346 C26.9757171,38.2379453 33.3918342,33.3008077 35.9832829,26.4745937 L36,26.47056 Z",
    id: "Combined-Shape",
    fill: "#E80000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,-0.425991724 C28.7172679,-0.425991724 37,8.14235187 37,18.7119393 C37,29.2815268 28.7172679,37.8498703 18.5,37.8498703 C8.28273214,37.8498703 0,29.2815268 0,18.7119393 C0,8.14235187 8.28273214,-0.425991724 18.5,-0.425991724 Z M18.5,11.3511966 C14.5702816,11.3511966 11.3846154,14.6467134 11.3846154,18.7119393 C11.3846154,22.7771652 14.5702816,26.072682 18.5,26.072682 C22.4297184,26.072682 25.6153846,22.7771652 25.6153846,18.7119393 C25.6153846,14.6467134 22.4297184,11.3511966 18.5,11.3511966 Z",
    id: "Combined-Shape",
    fill: "#FF0000"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapRed);
export default ForwardRef;